module.exports = __webpack_public_path__ + "static/media/ketogenic-cookbook-1.5f38ca57.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ketogenic-cookbook-1.png
// module id = 40
// module chunks = 0